module.exports = __webpack_public_path__ + "img/their_first_home.8d6f3682.png";